import { render, staticRenderFns } from "./Mall.vue?vue&type=template&id=870784ce&scoped=true&"
import script from "./Mall.vue?vue&type=script&lang=js&"
export * from "./Mall.vue?vue&type=script&lang=js&"
import style0 from "./Mall.vue?vue&type=style&index=0&id=870784ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870784ce",
  null
  
)

export default component.exports